/**
 * 按日期查询拍卖场次
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取出库管理列表
// 接口地址   /api/v1/auctions/outbound_requests
Mock.mock(/auctions\/outbound_requests\?/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'page': 1,
    'count': 10,
    'total_count': 55,
    'outbounds|10': [{
      'id|+1': 1, // 出库申请id
      'type': 4, // 出库类型
      'type_name': '特殊出库', // 出库类型名称
      'status': 1, // 状态
      'status_code': 'created',
      'auction_car_id|+3': 201, // 车辆id
      'car_image': Mock.Random.dataImage('200x133'), // 车辆照片
      'car_model_name': '丰田RAV4荣放荣放BLAH荣放BLAHBLAH' // 车型名称
    }]
  }
})

// 获取出库信息
// 接口地址   /api/v1/auctions/outbound_requests/<int:outbound_id>
Mock.mock(/auctions\/outbound_requests\/\d+/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'car_info': {
      'car_id': 1000, // 车辆id
      'car_image': Mock.Random.dataImage('200x133'), // 车辆图片
      'car_model_name': '一汽夏利blahblahblah', // 车型
      'vin': 'XXXXXXXXXXX', // 车架号
      'plate_number': '粤ASBCHD', // 车牌
      'contract_price': 100000 // 收车实价
    },
    'ob_request': { // 跟全部车辆列表中车辆信息的response返回类似，不同类型的出库返回的字段不同，本接口增加了type,type_name表示出库类型和status表示出库申请状态
      'ob_request_id': 111, // 出库申请id
      'is_submitter': true, // 本员工提交
      'type': 1, // 出库类型，详情请看
      'type_name': '零售',
      'type_code': 'batch_sale',
      'status': 1,
      'status_code': 'manager_approved',
      'car_income': 60000, // 水平总收入
      'car_cost': 50000, // 特殊出库的综合成本/报废出库的车辆成本/零售出库的收车合同价/批售出库的收车合同价
      'car_gross_profit': 12300, // 水平总毛利
      'deal_price': '零售成交价格',
      'maintenance_cost': 200000, // 整备费用
      'other_cose': 1200, // 其他费用
      'transfer_fee': 1300, // 过户费
      'employee_id': 111, // 销售人员id
      'employee_name': '赵本山', // 销售人员名
      'buyer_mobile': 13200000000, // 买家电话
      'buyer_name': '小沈阳', // 买家姓名
      'dealer_name': '范冰冰', // 批售对象名
      'dealer_type': 'lixin', // 批售对象类型
      'transaction_date': '2018-6-11', // 成交日期或特殊出库的出库日期
      'remark': '我是备注',
      'images|5': [{
        'code': 'id_card_a',
        'name': '身份证正面',
        'src': Mock.Random.dataImage('200x100')
      }]
    },
    'traces': [{ // 按时间排序，一共最多有三个这样的对象
      'status': 'approved',
      'operator_id': 1, // 出库申请人id/二手车经理id/财务id
      'operator_name': '莱昂纳多', // 申请人名/二手车经理名/财务名
      'operated_at': '2018-6-20 08:08', // 操作时间
      'role_names': '二手车评估师/二手车经理/财务', // 角色权限，可能很长一串
      'mobile': 13100000000, // 联系电话
      'review_note': '这是审核意见这是审核意见这是审核意见这是审核意见这是审核意见这是审核意见' // 二手车经理和财务审核时的备注
    }, { // 按时间排序，一共最多有三个这样的对象
      'status': 'approved',
      'operator_id': 1, // 出库申请人id/二手车经理id/财务id
      'operator_name': '莱昂纳多', // 申请人名/二手车经理名/财务名
      'operated_at': '2018-6-20 08:08', // 操作时间
      'role_names': '二手车评估师/二手车经理/财务', // 角色权限，可能很长一串
      'mobile': 13100000000, // 联系电话
      'review_note': '这是审核意见' // 二手车经理和财务审核时的备注
    }, { // 按时间排序，一共最多有三个这样的对象
      'status': 'rejected',
      'operator_id': 1, // 出库申请人id/二手车经理id/财务id
      'operator_name': '莱昂纳多', // 申请人名/二手车经理名/财务名
      'operated_at': '2018-6-20 08:08', // 操作时间
      'role_names': '二手车评估师/二手车经理/财务', // 角色权限，可能很长一串
      'mobile': 13100000000, // 联系电话
      'review_note': '这是审核意见' // 二手车经理和财务审核时的备注
    }]
  }
})

// 提交出库审核
// 接口地址   /api/v1/auctions/outbound_requests/<int:obrequest_id>/review/{role}
Mock.mock(/auctions\/outbound_requests\/\d+\/review\/manager/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {}
})
